export async function geocodeAddress(address) {
  const apiKey = 'AIzaSyBnl5SgVn4G03GwG7zKvQCI4dTEBpAwf00';
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.status === 'OK') {
      const location = data.results[0].geometry.location;
      return { latitude: location.lat, longitude: location.lng };
    } else {
      console.error('Error geocoding address');
      return {};
    }
  } catch (error) {
    console.error('Error geocoding address');
  }
}
